<template>
    <div v-if="farmers.length > 0" class="my-4">
        <div class="mt-2 pb-2">
            <table
                class="table-auto min-w-full divide-y divide-gray-400 border-b border-gray-400 border-collapse rounded-lg">
                <thead>
                    <tr class="bg-gray-200 font-bold text-sm text-gray-900">
                        <th scope="col" class="px-1 py-2.5 text-left">
                            Name
                        </th>
                        <th scope="col" class="px-1 py-2.5 text-left">
                            Address
                        </th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(farmer, index) in farmers" :key="index"
                        class="odd:bg-white even:bg-slate-100 text-gray-900 text-sm"
                        >
                        <td class="px-1 py-2.5">
                            <span>
                                {{ farmer.name }}
                            </span>
                        </td>
                        <td class="px-1 py-2.5">
                            {{ farmer.address }}
                        </td>
                        <td class="px-1 py-2.5 w-10">
                            <index-menu-item :links="farmerLinks(farmer)" />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <div v-if="farmers.length === 0" class="bg-white px-6 py-4 my-4">
        <strong>No farmers found.</strong>
    </div>
</template>

<script>
import  IndexMenuItem from '@/Components/IndexMenuItem';

export default {
    components: {
        IndexMenuItem
    },
    props: {
        farmers: Array,
    },
    methods: {
        farmerLinks(farmer) {
            return {
                'View Farmer' : route('app.farmer.view', farmer.id),
                'Edit Farmer' : route('app.farmer.edit', farmer.id)
            }         
        }
    }
};
</script>
